var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',_vm._l((12),function(mes){return _c('b-col',{key:mes,staticStyle:{"padding-right":"5px","padding-left":"5px"},attrs:{"md":"4"}},[_c('quadro-dados',{attrs:{"titulo":_vm.meses[mes],"dados":_vm.obterMesPorCompetencia(mes),"nomesDados":_vm.nomesDados,"tiposDados":_vm.tiposDados,"descricoes":_vm.descricoes}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }